import withPage from '@lib/page';
import { ProductPage } from '@views/pages/product';

export default withPage(ProductPage);
